import { InfrastructureSection, InfrastructureCategoriesContainer } from '../../../packages/InfrastructureMobile';
import { MapFragment, MapStoreProvider } from '../../../packages/MapMobile';
import { Section } from 'shared/components/Section';
import { useYandexApiKeys } from 'shared/hooks';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { useMapActions, useInfrastructureDistance, useInfrastructureCategoriesRequest } from './hooks';
import { selectInfrastructure } from 'shared/selectors/infrastructure';
import { useSelector } from 'react-redux';
import { selectHouseCoordinates, selectHouseId, selectRegionId } from 'shared/selectors/houseInfo';
import { FC } from 'react';
import { EInfrastructureStatus } from 'shared/types/infrastructure';
import { SkeletonInfrastructure } from 'shared/components/SkeletonList';
import {
  trackInfrastructureCategoryModalOpen,
  trackInfrastructureCategoryClick,
  trackInfrastructurePinClick,
  trackInfrastructureMapOpenByMapFragment,
} from './tracking';

export const InfrastructureSectionContainer: FC = () => {
  const context = useApplicationContext();
  const houseId = useSelector(selectHouseId);
  const { yandexApiKey, yandexSuggestApiKey } = useYandexApiKeys();
  const { data: infrastructureCategories, status } = useSelector(selectInfrastructure);
  const regionId = useSelector(selectRegionId);
  const coordinates = useSelector(selectHouseCoordinates);
  const { selectInfrastructureItemOnMap, selectInfrastructureCategoryOnMap, openMapModal } = useMapActions();
  const distance = useInfrastructureDistance();

  useInfrastructureCategoriesRequest();

  return (
    <Section title="Расположение">
      {status === EInfrastructureStatus.Pending ? (
        <SkeletonInfrastructure />
      ) : (
        <InfrastructureSection
          distance={distance}
          mapFragment={
            <MapFragment
              apiKey={yandexApiKey as string}
              suggestApiKey={yandexSuggestApiKey as string}
              context={context}
              infrastructureCategories={infrastructureCategories}
              houseId={houseId}
              coordinates={coordinates}
              regionId={regionId}
              onMapPreviewClick={openMapModal}
              onMapOpen={trackInfrastructureMapOpenByMapFragment}
            />
          }
          categories={
            <InfrastructureCategoriesContainer
              categories={infrastructureCategories}
              regionId={regionId}
              onItemClick={selectInfrastructureItemOnMap}
              onCategorySelect={selectInfrastructureCategoryOnMap}
              openMapModal={openMapModal}
              onCategoryModalOpen={trackInfrastructureCategoryModalOpen}
            />
          }
        />
      )}
    </Section>
  );
};

export function InfrastructureSectionWrapper() {
  return (
    <MapStoreProvider
      onInfrastructurePinClick={trackInfrastructurePinClick}
      onInfrastructureCategoryClick={trackInfrastructureCategoryClick}
    >
      <InfrastructureSectionContainer />
    </MapStoreProvider>
  );
}
